import ApiClient from './ApiClient';

class CrmDealsAPI extends ApiClient {
  constructor() {
    super('crm_deals', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    if (Array.isArray(data?.attachments) && data.attachments.length > 0) {
      return axios.post(this.url, this.buildMultipartPayload(data), {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }

    return axios.post(this.url, { crm_deal: data });
  }

  update(id, data) {
    if (Array.isArray(data?.attachments) && data.attachments.length > 0) {
      return axios.patch(`${this.url}/${id}`, this.buildMultipartPayload(data), {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }

    return axios.patch(`${this.url}/${id}`, { crm_deal: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  move(id, stageId) {
    return axios.patch(`${this.url}/${id}/move`, { stage_id: stageId });
  }

  finalize(id, finalStageType) {
    return axios.post(`${this.url}/${id}/finalize`, { final_stage_type: finalStageType });
  }

  funnel(params = {}) {
    return axios.get(`${this.url}/funnel`, { params });
  }

  getByContact(contactId, params = {}) {
    return axios.get(this.url, {
      params: { contact_id: contactId, ...params },
    });
  }

  buildMultipartPayload(data) {
    const payload = new FormData();
    const dealData = { ...data };

    if (Array.isArray(dealData.deal_products)) {
      payload.append('crm_deal[deal_products]', JSON.stringify(dealData.deal_products));
      delete dealData.deal_products;
    }

    if (Array.isArray(dealData.retained_attachment_ids)) {
      dealData.retained_attachment_ids.forEach(id => {
        payload.append('crm_deal[retained_attachment_ids][]', id);
      });
      delete dealData.retained_attachment_ids;
    }

    if (Array.isArray(dealData.attachments)) {
      dealData.attachments.forEach(file => {
        payload.append('crm_deal[attachments][]', file);
      });
      delete dealData.attachments;
    }

    Object.entries(dealData).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      payload.append(`crm_deal[${key}]`, value);
    });

    return payload;
  }
}

export default new CrmDealsAPI();
